import { put, takeLatest, call } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

function* getInstantExchageOrders({ payload }) {
  try {
    const { data, status } = yield call(
      api.profile.getUserInstantExchangeOrders,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_INSTANT_EXCHANGE_ORDERS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_INSTANT_EXCHANGE_ORDERS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* instantExchangeOrders() {
  yield takeLatest(types.GET_INSTANT_EXCHANGE_ORDERS_START, getInstantExchageOrders);
}
